import { http, HttpResponse } from 'msw';

export const validateGovernmentIdHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/validation/government_id', async () => {
        return HttpResponse.json({
            status: 'VALID',
            ruleParameterName: 'string',
            sourceParameterName: 'string',
            validationMessageKey: 'string',
        });
    }),
];
